<template>
  <div class="component-select-wrap ">
    <!-- 区域 选择 -->
    <div class="component-select area-select" @mouseover="changeEventHandler" @mouseout="changeEventHandler">
      <CheckInput
        class="input-select noevent z2 w-normal"
        :isFocus="inputFocus"
        :isHover="inputHover"
        :label="label"
        v-model="inputVal"
        :disable="disable"
        :error="areaError"
        :isCheck="false"
        :id="areaId"
      />
      <div class="triangle-down z2" :class="selectVisible ? 'up' : ''"></div>
      <el-cascader
        class="el-cascader overlay w-normal"
        :value="value"
        :options="options"
        :props="props"
        @focus="changeEventHandler"
        @blur="changeEventHandler"
        @visible-change="visibleChagneHandler($event)"
        @change="onSelectChange"
        :disabled="disable"
      ></el-cascader>
      <div v-if="(startVerific && areaError) || areaError" class="errmsg">{{ areaErrmsg }}</div>
    </div>
    <!-- 学校选择 -->
    <div v-if="showSchool" class="addSchool-line">
      <!-- 新增学校 -->
      <CheckInput
        v-if="addNewSchool"
        class=" w-normal"
        label="学校"
        v-model="schoolData.schoolName"
        @blur="handleBlurAddInput"
        :id="schoolId"
        :startVerific="startVerific"
      />
      <!-- 学校 选择 -->
      <FilterSelect
        v-else
        class="component-select"
        label="学校"
        :options="schoolOptions"
        @change="handleChoiceSchool"
        v-model="schoolData.schoolId"
        :id="schoolId"
        :errmsg="schoolErrmsg"
        :startVerific="startVerific"
        @click="handleClick"
      />
      <div v-if="isHasSchool" class="addSchoolBtn" @click="handleAddSchool">{{ addNewSchool ? '从已有学校填写' : '没有找到你的学校？手动填写' }}</div>
      <!-- <div v-if="!addNewSchool && ((startVerific && schoolError) || schoolError)" class="errmsg">{{ schoolErrmsg }}</div> -->
    </div>
  </div>
</template>
<script>
import CheckInput from '../CheckInput/checkInput';
import FilterSelect from '../FilterSelect';
import { Api, Codes } from '../../../api';
/**
 * 学校选择组件
 * @module SchoolSelect
 */
export default {
  name: 'SchoolSelect',
  /**
   * @prop {String} isFlex 布局 flex 默认 normal
   * @prop {String} showSchool 是否显示学校
   * @prop {String} label 输入框标签
   * @prop {String} defaultVal 默认值
   * @prop {Boolean} disable 是否禁用 默认false
   * @prop {Boolean} error 是否错误状态 默认false
   * @prop {Boolean} schoolType 学校类型 university 大学 其余 不填
   */
  props: {
    isChina: {
      type: Boolean,
      default: false
    },
    isMainLand: {
      type: Boolean,
      default: false
    },
    isFlex: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showSchool: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: '学校所在区域'
    },
    defaultVal: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    areaId: {
      type: String,
      default: ''
    },

    schoolId: {
      type: String,
      default: ''
    },

    areaErrmsg: {
      type: String,
      default: '请选择区域'
    },
    schoolErrmsg: {
      type: String,
      default: '请选择或输入学校全名'
    },
    schoolType: {
      type: String,
      default: ''
    }
  },
  /**
   * @prop {Component} CheckInput 带验证的输入框
   * @prop {Component} Select 下拉框组件
   */
  components: {
    CheckInput,
    FilterSelect
  },
  /**
   * @prop {Boolean} inputHover 输入框是否hover
   * @prop {Boolean} inputFocus 输入框是否聚焦
   * @prop {Array} value
   * @prop {Boolean} addNewSchool 是否新增学校
   * @prop {Boolean} isHasSchool 当该区域没有学校时 主动隐藏 学校下拉
   * @prop {Array} valueId 选中的区域ID path
   * @prop {String} inputVal 作为显示的input 的val
   * @prop {Boolean} selectVisible 控制 三角形 旋转动画
   * @prop {Array} schoolOptions 学校选项
   * @prop {Array} options
   * @prop {Object} schoolData 返回的学校数据
   * @prop {Object} props
   */
  data() {
    const that = this;
    return {
      isUserChange: false, // 是否用户 主动改变参数

      areaError: false, // 选择框报错状态
      schoolError: false, // 选择框报错状态

      inputHover: false,
      inputFocus: false,
      // value: [],
      addNewSchool: false, // 是否新增学校
      isHasSchool: true, // 当该区域没有学校时 主动隐藏 学校下拉
      valueId: [], // 选中的区域ID path
      inputVal: '', // 学校区域 作为显示的input 的val
      selectVisible: false, // 控制 三角形 旋转动画
      // 学校选项
      schoolOptions: [
        // {
        //   value: '选项1',
        //   label: '黄金糕'
        // },
      ],
      options: [
        {
          value: 'zhinan',
          label: '指南',
          children: []
        }
      ],
      // 返回的 学校数据
      schoolData: {
        areaId: [], // 学校 区域ID 顺序依次为 国家 省/州 城市
        areaStr: '', // 学校区域展示
        schoolId: '', //学校ID
        schoolName: '' // 学校名称 新建/ 当前选中的学校名称
      },
      props: {
        expandTrigger: 'click',
        lazy: true,
        lazyLoad(node, resolve) {
          let path = node.path;
          let level = node.level;
          if (level === 3) {
            resolve();
            return;
          }
          that.handleExpandChange(path, resolve);
        }
      }
      // schoolTypeVal: '' // 学校类型 和 props 中对应
    };
  },
  computed: {
    schoolTypeVal() {
      let res = this.schoolType;
      return res;
    },
    selectWrapClass() {
      let ret = {};
      ret['flex'] = this.isFlex;
      return ret;
    }
  },
  watch: {
    // 防止 数据赋值的时候 由于延迟导致 赋值不及时
    value: {
      async handler(val) {
        this.schoolData = val;
        this.schoolData.schoolId = val.schoolId ? String(val.schoolId) : '';
        if (this.startVerific) this.areaError = this.schoolData.areaId.length === 0 ? true : false;
        if (!this.isUserChange) {
          this.isUserChange = true;
        }
        if (val?.areaId?.length !== 0) {
          await this.areaValueToLabel();
          // 获取学校数据
          await this.AutoGetSchools();
        }
      },
      deep: true
    }
    // schoolType(val) {
    //   this.schoolTypeVal = val;
    // }
  },
  async created() {
    // 初始化  赋值
    this.schoolData = this.value;
    this.schoolData.schoolId = String(this.value.schoolId);

    this.inputVal = this.value.areaStr;
    this.addNewSchool = this.value.schoolName ? true : false;

    // 改变数据格式 获取 school 数组
    if (this.schoolData.areaId.length !== 0) {
      await this.AutoGetSchools();
      await this.areaValueToLabel();
    }
    // 初始化 获取国家
    this.getCountries();
    if (this.startVerific) {
      this.areaError = this.schoolData.areaId.length === 0 ? true : false;
      this.schoolError = this.schoolData.schoolName === '' && !this.schoolData.schoolId ? true : false;
    }
  },
  methods: {
    // 区域 通过value 获取label路径
    async areaValueToLabel() {
      let result = '';
      let areaId = this.schoolData?.areaId;
      let res = null;
      let label = null;
      let parm = null;
      if (areaId.length === 0) return;
      // 获取国家
      res = await Api.get.getCountries();
      if (areaId?.[0] === '') return;
      label = this.getAreaValueToLabel(res.data, areaId[0]);
      result += label + '/';
      // 获取 省市
      parm = {
        country_id: areaId[0]
      };
      if (areaId?.[1] === '') return;
      res = await Api.get.getStates(parm);
      label = this.getAreaValueToLabel(res.data, areaId[1]);
      areaId.length === 2 ? (result += label) : (result += label + '/');
      // 获取城市
      if (areaId.length >= 3) {
        parm = {
          state_id: areaId[1]
        };
        res = await Api.get.getCities(parm);
        if (areaId?.[2] === '') return;
        label = this.getAreaValueToLabel(res.data, areaId[2]);
        areaId.length === 3 ? (result += label) : (result += label + '/');
      }
      this.inputVal = result;
      return result;
    },
    getAreaValueToLabel(_arr, val) {
      let label = '';
      for (let i = 0; i < _arr?.length; i++) {
        const item = _arr[i];
        if (item.id === Number(val)) {
          label = item.name;
          return label;
        }
      }
    },
    // 新增学校 blur 事件
    handleBlurAddInput() {
      this.schoolData.schoolId = '';
      // this.schoolError = this.schoolData.schoolName === '' ? true : false;
      this.schoolError = this.schoolData.schoolName === '' && !this.schoolData.schoolId ? true : false;

      this.$emit('blurSchool', this.schoolError, this.schoolId, this.schoolErrmsg);
    },
    // 学校选择 点击 事件
    handleClick() {
      this.isUserChange = true;
      this.getSchools();
      this.$emit('click');
    },
    /**
     * @description 获取国家
     * @function getCountries
     */
    async getCountries() {
      let res = await Api.get.getCountries();
      if (res.status !== Codes.SUCCESS) return;
      if (this.isChina) {
        res.data = res.data.filter(item => item.id === 1);
      }
      let data = this.initResponseData(res.data);
      this.options = data;
    },
    // 获取省/州
    /**
     * @description 获取省/州
     * @function getRegionStates
     * @param {String} _countryId 国家id
     * @param {Number} _countriesIndex 国家index
     * @param {Function} resolve 回调
     */
    async getRegionStates(_countryId, _countriesIndex, resolve) {
      const that = this;
      let parm = {
        country_id: _countryId
      };
      let res = await Api.get.getStates(parm);
      if (res.status !== Codes.SUCCESS) return;
      if (this.isMainLand) {
        let ids = ['3032', '3033', '3125'];
        res.data = res.data.filter(item => !ids.find(id => id === item.id.toString()));
      }
      if (res.data.length === 0) {
        resolve();
        return;
      }
      that.options[_countriesIndex]['children'] = that.initResponseData(res.data, 2);
      let data = that.initResponseData(res.data);
      resolve(data);
    },
    /**
     * @description 获取城市
     * @function getCities
     * @param {String} _cityId 城市id
     * @param {String} _countryIdx 国家di
     * @param {String} _statesIdx 区id
     * @param {Function} resolve 回调
     */
    async getCities(_cityId, _countryIdx, _statesIdx, resolve) {
      const that = this;
      let parm = {
        state_id: _cityId
      };
      let res = await Api.get.getCities(parm);
      if (res.status !== Codes.SUCCESS) return;
      if (res.data.length === 0) {
        resolve();
        return;
      }
      that.options[_countryIdx].children[_statesIdx]['children'] = that.initResponseData(res.data, 3);
      let data = that.initResponseData(res.data, 2);
      resolve(data);
    },
    /**
     * @description 获取学校
     * @function getSchools
     */
    async getSchools() {
      this.valueId = this.schoolData.areaId;
      if (this.valueId.length === 0) return;
      let parm = {
        country_id: this.valueId[0], // 国家ID
        state_id: this.valueId[1], // 省
        city_id: this.valueId[2] ? this.valueId[2] : 0, // 城市
        type: this.schoolType, // 大学，高中 	university- 大学 其余都不传
        name: ''
      };
      let res = await Api.get.getSchools(parm);
      if (res.status !== Codes.SUCCESS) return;
      if (res.data.length === 0) {
        this.addNewSchool = true;
        this.isHasSchool = false;
        return;
      }
      this.isHasSchool = true;
      this.addNewSchool = this.schoolData.schoolId === '0' && this.schoolData.schoolName ? true : false;
      this.schoolOptions = this.initResponseData(res.data, true);
    },
    /**
     *  进页面 自动填入表单时 调用
     */
    async AutoGetSchools() {
      this.valueId = this.schoolData.areaId;
      if (this.valueId.length === 0) return;
      let parm = {
        country_id: this.valueId[0], // 国家ID
        state_id: this.valueId[1], // 省
        city_id: this.valueId[2], // 城市
        type: this.schoolType // 大学，高中 	university- 大学 其余都不传
      };
      if (this.value.schoolId && this.value.schoolId !== 'null') {
        parm['school_id'] = this.value.schoolId;
        let res = await Api.get.getSchools(parm);
        if (res.status !== Codes.SUCCESS) return;
        this.schoolOptions = this.initResponseData(res.data, true);
      } else {
        if (this.value.schoolName) this.addNewSchool = true;

        return;
      }
    },
    /**
     * @description 展开操作
     * @function handleExpandChange
     * @param {String} val 数据
     * @param {Function} resolve 回调
     */
    handleExpandChange(val, resolve) {
      const that = this;
      let curLevel = val.length;
      let id = 0;
      let index = 0;
      switch (curLevel) {
        case 1:
          id = val[curLevel - 1];
          index = that.getValueToIndex(this.options, id);
          // 请求
          that.getRegionStates(id, index, resolve);
          break;
        case 2:
          // country index
          var country_id = val[0];
          var country_idx = that.getValueToIndex(this.options, country_id);
          // state Index
          id = val[curLevel - 1];
          index = that.getValueToIndex(this.options[country_idx].children, id);
          // 请求
          that.getCities(id, country_idx, index, resolve);
          break;
        default:
          resolve();
          break;
      }
    },
    /**
     * @description 没找到学校 点击 添加
     * @function handleAddSchool
     */
    handleAddSchool() {
      this.isUserChange = true;

      this.addNewSchool = !this.addNewSchool;
      this.schoolData.schoolId = '';
      this.schoolData.schoolName = '';
      // 检查 是否 空数据
      this.checkSchoolSelectInput();
    },
    /**
     * @description 通过 value 获取 数组的下标
     * @function
     * @param {Array} _arr 层级数组
     * @param {String} _value id
     * @return {String} 数组下标
     */
    getValueToIndex(_arr, _value) {
      let result = '';
      for (let i = 0; i < _arr.length; i++) {
        const item = _arr[i];
        if (item.value === _value) {
          result = i;
          return result;
        }
      }
    },
    /**
     * @description ajax返回的城市 学校 数据
     * @function initResponseData
     * @param {Array} _arr 数据id
     * @return {Array}
     */
    initResponseData(_arr, level) {
      let result = [];
      _arr.forEach(item => {
        let temp = {
          value: String(item.id),
          label: item.name,
          leaf: level,
          aliases: item.aliases ? item.aliases : null
        };
        result.push(temp);
      });
      return result;
    },
    /**
     * @event input 暴漏input事件
     */
    /**
     * @description 选择学校
     * @function handleChoiceSchool
     * @param {String} label 学校标签
     */
    handleChoiceSchool(label) {
      this.schoolData.schoolName = label;
      this.$emit('input', this.schoolData);
      this.checkSchoolSelectInput();
    },
    // 监听 按钮状态 切换背景颜色
    /**
     * @description 监听 按钮状态 切换背景颜色
     * @function changeEventHandler
     * @param {Object} event 事件对象
     */
    changeEventHandler(event) {
      const that = this;
      let eventType = event.type;
      switch (eventType) {
        case 'mouseover':
          if (that.error) return;
          if (that.disable) return;
          that.inputHover = true;
          break;
        case 'mouseout':
          if (that.inputFocus) return;
          if (that.error) return;
          if (that.disable) return;
          // that.inputFocus = false;
          that.inputHover = false;
          break;
        case 'focus':
          if (that.error) return;
          that.inputFocus = true;
          break;
        case 'blur':
          that.inputFocus = false;
          break;
        default:
          break;
      }
    },
    /**
     * @description 下拉框 显示/ 隐藏状态监听  ------ 改变 focus 状态
     * @function visibleChagneHandler
     * @param {Boolean} val
     */
    visibleChagneHandler(val) {
      if (this.error) return;
      this.selectVisible = val;
      if (val) this.inputFocus = true;
    },
    /**
     * @event input 暴漏input事件
     */
    /**
     * @description 区域国家 选项确认点击
     * @function onSelectChange
     * @param {String} val 区域ID
     */
    onSelectChange(val) {
      this.isUserChange = true;

      // 重置 学校 数据
      this.schoolOptions = [];
      this.schoolData.schoolName = '';
      this.schoolData.schoolId = '';
      // 将数据 转格式 变为input 展示数据
      let label = this.valueToLabel(val);
      this.inputVal = label;
      // 丢出数据
      this.schoolData.areaId = val;
      this.schoolData.areaStr = label;
      this.$emit('input', this.schoolData);
      // 改变数据格式 获取 school 数组
      this.valueId = val;
      this.getSchools();

      this.checkAreaSelectInput();
      if (this.error) return;
      this.inputFocus = val === '' ? false : true;
    },
    /**
     * @description 返回结果路径字符串 显示
     * @function valueToLabel
     * @param {Array} valArr 区域国家ID 数组
     */
    valueToLabel(valArr) {
      const that = this;
      let options = that.options;
      let label = '';
      let labelArr = [];
      for (let i = 0; i < valArr.length; i++) {
        let val = valArr[i];
        switch (i) {
          case 0:
            var res1 = that.getLabel(options, val);
            labelArr.push(res1.index);
            label += res1.label + '/';
            break;
          case 1:
            var res2 = that.getLabel(options[labelArr[0]].children, val);
            labelArr.push(res2.index);
            label += res2.label + '/';

            break;
          case 2:
            var res3 = that.getLabel(options[labelArr[0]].children[labelArr[1]].children, val);
            labelArr.push(res3.index);
            label += res3.label + '/';
            break;
          default:
            break;
        }
      }
      label = label.substring(0, label.length - 1);
      return label;
    },

    /**
     * @description 遍历 options 中 value 对应的 label
     * @function getLabel
     * @param {Array} array
     * @param {String} value
     * @return {Object}
     */
    getLabel(array, value) {
      let result = {
        label: '',
        index: ''
      };
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        if (item.value === value) {
          result = {
            label: item.label,
            index: i
          };
          return result;
        }
      }
    },
    // 验证 区域是否为空
    checkAreaSelectInput() {
      // this.areaError = this.inputVal === '' ? true : false;
      this.areaError = this.schoolData.areaId.length === 0 ? true : false;

      this.$emit('blur', this.areaError, this.areaId, this.areaErrmsg);
    },
    // 验证 学校 是否为空
    checkSchoolSelectInput() {
      // this.schoolError = this.schoolData.schoolName === '' ? true : false;
      this.schoolError = this.schoolData.schoolName === '' && !this.schoolData.schoolId ? true : false;
      this.$emit('blurSchool', this.schoolError, this.schoolId, this.schoolErrmsg);
    }
  }
};
</script>
<style lang="less" src="./schoolSelect.less" scoped></style>

<style lang="less">
.el-cascader__dropdown {
  border: 0;
  border-radius: 2px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 1px rgba(0, 0, 0, 0.05);
}
.el-cascader-node.is-active {
  color: @color-17181A !important;
  background-color: @color-FAFAFA;
}
.el-cascader-node.is-active:hover {
  color: @color-17181A !important;
  background-color: @color-FAFAFA;
}
.el-cascader-node:not(.is-disabled):focus,
.el-cascader-node:not(.is-disabled):hover {
  background-color: @color-FAFAFA;
}
.el-cascader-node.in-active-path {
  color: @color-17181A !important;
  background-color: @color-FAFAFA;
}

.el-cascader-menu {
  color: @color-7C7D80 !important;
  border-right-color: @color-F5F5F5;
}

@media screen and(max-width: 750px) {
  .el-cascader-menu {
    min-width: 105px;
    max-width: 105px;
  }
  .el-cascader-menu__wrap {
    height: 210px;
  }
}
</style>
